<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<button #focusableEleTop class="focusable-element"></button>
<div class="container" (keydown)="onKeyDown($event)">
    <div class="row">
        <div class="col-16">
            <h1 class="medium">Tell us about the applicant (Employer Group Enrollment) </h1>
            <br />
        </div>
    </div>
    <div class="row" *ngIf="hasError">
        <div class="col-24">
            <div class="alert danger" role="alert" aria-live="assertive">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages"aria-atomic="true" role="listitem">{{error}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="IsErrorMesssage" role="alert" aria-live="assertive">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of errorMessage">{{error}}</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Agent ID for this enrollment:'" [text]="agentUserName"
                                    (onValueChange)="enrollmentViewModel.AGENTNAME = $event" [validators]="[notBlankValidator]"
                                    [disabled]="isValidAgent">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8" *ngIf="false">
            <div class="input-wrapper">
                <button class="button primary" (click)="onContinue()">Change</button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Desired Plan'" [text]="enrollmentViewModel.SINGLEGRPNAME" [disabled]="isValidAgent">
                </ValidatedTextField>

            </div>
        </div>
    </div>


    <div class="row">
        <div class="col-10">
            <div>
                <label></label>
                <JQDatePicker for="'AppDate'" [label]="'Application Receipt Date (Date of receipt of completed application by Plan):'" id="AppDate" [selectedDate]="enrollmentViewModel.APPDT"
                              (elementClicked)="appRecievedDateChange($event)">
                </JQDatePicker>
            </div>
        </div>
        <div class="col-6">
            <div class="input-wrapper">
                                <JQDatePicker for="'EffDate:'" [label]="'Effective Date:'" id="EffDate" [selectedDate]="enrollmentViewModel.EFFDT"
                              (elementClicked)="enrollmentViewModel.EFFDT = $event">
                </JQDatePicker>

            </div>
        </div>
    </div>


    <div class="row" *ngIf="false">
        <div class="col-16">
            <div class="input-wrapper">
                <ValidatedCheckbox class="centered-checkbox" [id]="'po-box'"
                                   [label]="'I suggested or recommended a plan'" [checked]="enrollmentViewModel.POBOX"
                                   (onValueChange)="enrollmentViewModel.POBOX= $event">
                </ValidatedCheckbox>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-6">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Last Name'" [id]="'LastName'" [requiredField]="true"
                                    [text]="enrollmentViewModel.APPLN" (onValueChange)="enrollmentViewModel.APPLN = $event"
                                    [validators]="[notBlankValidator]">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-6">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'First Name'" [id]="'FirstName'" [requiredField]="true"
                                    [text]="enrollmentViewModel.APPFN" (onValueChange)="enrollmentViewModel.APPFN = $event"
                                    [validators]="[notBlankValidator]">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-4">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'MI (optional)'"  [text]="enrollmentViewModel.APPMI"
                                    [maxlength]="1" (onValueChange)="enrollmentViewModel.APPMI = $event" [validators]="[]">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-4">
            <div class="input-wrapper">
                <ValidatedDropDown class="wide" [selectedValue]="enrollmentViewModel.TITLE" [label]="'Title (optional)'"
                                   (onValueChange)="enrollmentViewModel.TITLE = $event" [options]="titleOptions">
                </ValidatedDropDown>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-6">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Date of Birth'" [id]="'DateofBirth'" [requiredField]="true"
                                    [text]="enrollmentViewModel.APPDOB" (onValueChange)="enrollmentViewModel.APPDOB = $event"
                                    [validators]="[notBlankValidator]" maxlength="10">

                </ValidatedTextField>
                <span>Format as MM/DD/YYYY</span>
            </div>
        </div>
        <div class="col-4">
            <ValidatedRadioButtonGroup [options]="genderOptions" label="Sex"
                                       [selectedValue]="enrollmentViewModel.APPGEN" [radioGroupName]="'genderOptions'"
                                       (onValueChange)="enrollmentViewModel.APPGEN = $event">
            </ValidatedRadioButtonGroup>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <MaskedValidatedTextField class="field" [label]="'Phone Number (optional)'" id="authrep-phone"
                                          [text]="enrollmentViewModel.APPPHONE" (onValueChange)="enrollmentViewModel.APPPHONE = $event"
                                          [maxlength]="10" [inputMask]="phoneNumberInputMask">
                </MaskedValidatedTextField>
            </div>
        </div>
    </div>
    <fieldset>
        <legend> Permanent Address:</legend>
        <div class="row">
            <div class="col-24" *ngIf="visibleFrom2026">
                <div class="bottom-20">
                    <ValidatedCheckbox [id]="'poBox-Check'"
                                       [label]="'Check if enrollee is currently experiencing homelessness'"
                                       [checked]="isPOBox"
                                       (onValueChange)="poBoxChecked($event)">
                    </ValidatedCheckbox>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Permanent Street Address Line 1 (PO Box is not allowed)'"
                                        [requiredField]="true"
                                        [text]="enrollmentViewModel.APPADD1" [validators]="[notBlankValidator]" (blur)="onBlur()"
                                        (onValueChange)="enrollmentViewModel.APPADD1 = $event" maxlength="40">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Permanent Street Address Line 2 (optional)'"
                                         [text]="enrollmentViewModel.APPADD2"
                                        (blur)="onBlur()" (onValueChange)="enrollmentViewModel.APPADD2= $event" maxlength="40">
                    </ValidatedTextField>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'City'" [id]="'City'" [requiredField]="true"
                                        [text]="enrollmentViewModel.APPCITY" [validators]="[notBlankValidator]" (blur)="onBlur()"
                                        (onValueChange)="enrollmentViewModel.APPCITY= $event" maxlength="40">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-5">
                <div class="input-wrapper">
                    <ValidatedDropDown class="wide" [selectedValue]="enrollmentViewModel.APPST" [label]="'State'"
                                       [disabled]="disabledstate" (onValueChange)="SelectState($event)" [options]="states"
                                       (blur)="onBlur()">
                    </ValidatedDropDown>
                </div>
            </div>
            <div class="col-3">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Zip'" [id]="'Zip'" [requiredField]="true"
                                        [text]="enrollmentViewModel.APPZIP" [validators]="[notBlankValidator]" (blur)="onBlur()"
                                        (onValueChange)="enrollmentViewModel.APPZIP = $event" maxlength="5">
                    </ValidatedTextField>
                </div>
            </div>

        </div>
    </fieldset>
    <div class="row">
        <div class="col-24">

            <div class="bottom-20">
                <ValidatedCheckbox [id]="'same-as-business-address'"
                                   [label]="'Mailing Address (only if different from Permanent Residence Address):'"
                                   [checked]="enrollmentViewModel.ISSAMEADDRESS"
                                   (onValueChange)="clickOnSameAsBusinessAddress($event)">
                </ValidatedCheckbox>
            </div>
        </div>
    </div>
    <div *ngIf="IsSameAddress">
        <fieldset>
            <legend>Mailing Address:</legend>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Street Address Line 1'" 
                                            [requiredField]="true" [text]="enrollmentViewModel.MAILADD1" [validators]="[notBlankValidator]"
                                            (blur)="onBlur()" [disabled]="disabled" (onValueChange)="enrollmentViewModel.MAILADD1= $event"
                                            maxlength="40">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Street Address Line 2 (optional)'"
                                             [text]="enrollmentViewModel.MAILADD2"
                                            (blur)="onBlur()" [disabled]="disabled" (onValueChange)="enrollmentViewModel.MAILADD2= $event"
                                            maxlength="40">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'City'"  [requiredField]="true"
                                            [text]="enrollmentViewModel.MAILCITY" [validators]="[notBlankValidator]" (blur)="onBlur()"
                                            [disabled]="disabled" (onValueChange)="enrollmentViewModel.MAILCITY = $event" maxlength="40">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-5">
                    <div class="input-wrapper">
                        <ValidatedDropDown class="wide" [selectedValue]="enrollmentViewModel.MAILST" [label]="'State'"
                                           [disabled]="disabled" (onValueChange)="enrollmentViewModel.MAILST = $event"
                                           [options]="mailingstates" (blur)="onBlur()">
                        </ValidatedDropDown>
                    </div>
                </div>
                <div class="col-3">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Zip'" [requiredField]="true"
                                            [text]="enrollmentViewModel.MAILZIP" [validators]="[notBlankValidator]" (blur)="onBlur()"
                                            [disabled]="disabled" (onValueChange)="enrollmentViewModel.MAILZIP = $event" maxlength="5">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>

    <div class="row">
        <div class="col-16">
            <ValidatedRadioButtonGroup label="Would you like to provide an emergency contact for (name of beneficiary) account? (optional)"
                                       [options]="emergencycontactOptions" [selectedValue]="enrollmentViewModel.EMERIND"
                                       [radioGroupName]="'emergencycontactOptions'" (onValueChange)="ShowrEmergencyContactOptions($event)">
            </ValidatedRadioButtonGroup>
        </div>
    </div>
    <div class="row">
        <fieldset class="radio" *ngIf="IsEmergencyYes">
            <legend>Emergency Contact Info:</legend>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Emergency contact:'"  [maxlength]="50"
                                            [text]="enrollmentViewModel.EMERNAME"
                                            (onValueChange)="enrollmentViewModel.EMERNAME= $event">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <MaskedValidatedTextField class="field" [label]="'Phone Number:(numbers only)'" id="emer-phone"
                                                  [text]="enrollmentViewModel.EMERPHONE"
                                                  (onValueChange)="enrollmentViewModel.EMERPHONE = $event" [maxlength]="10"
                                                  [inputMask]="phoneNumberInputMask">
                        </MaskedValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Relationship to You:'"
                                            [maxlength]="50" [text]="enrollmentViewModel.EMERREL"
                                            (onValueChange)="enrollmentViewModel.EMERREL= $event">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>

        </fieldset>
    </div>

    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField class=""
                                    [label]="'Email Address (optional):'"
                                    id="EmailAddress"
                                    [text]="enrollmentViewModel.APPEMAIL"
                                    maxlength="100"
                                    (onValueChange)="enrollmentViewModel.APPEMAIL = $event">

                </ValidatedTextField>
            </div>
        </div>
    </div>


    <div class="row">
        <div class="col-16">
            <p>
                Please take out your red, white, and blue Medicare card to complete this section.
            </p>
            <ul role='list'>
                <li role='listitem'>
                    • Fill out this information as it appears on your Medicare card <br /> - OR -
                </li>
                <li role='listitem'>
                    • Attach a copy of your Medicare card or your letter from Social Security or the
                    Railroad Retirement Board.
                </li>
                <br />
            </ul>
        </div>
    </div>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField class="" [label]="'Medicare Number'" [id]="'Medicare-Number'" [requiredField]="true"
                                    [maxlength]="12" [text]="enrollmentViewModel.HICN"
                                    (onValueChange)="medicareNumberValueChange($event)" (blur)="HICNBlur()"
                                    [validators]="[notBlankValidator]">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="input-wrapper">
                             <JQDatePicker for="MEDA" [label]="'Medicare Part A (Hospital) Effective Date (optional):'" id="MEDA" [selectedDate]="enrollmentViewModel.MEDA"
                              (elementClicked)="enrollmentViewModel.MEDA = $event">
                </JQDatePicker>
                <div class="field__message">Format as MM/DD/YYYY</div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="input-wrapper">
                <label></label>
                <JQDatePicker for="MEDB" [label]="'Medicare Part B (Medical) Effective Date (optional):'" id="MEDB" [selectedDate]="enrollmentViewModel.MEDB"
                              (elementClicked)="enrollmentViewModel.MEDB = $event">
                </JQDatePicker>
                <div class="field__message">Format as MM/DD/YYYY</div>
            </div>
            <p>
                You must have Medicare Part A or Part B (or both) to join a Medicare prescription drug plan.
                <br />
                <br />
            </p>
        </div>

    </div>

    <div *ngIf="showSTCOBFields">
        <fieldset>
            <legend>STCOB Fields</legend>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField class="field field--single" [label]="'Secondary Member ID'"
                                             [requiredField]="true" [text]="enrollmentViewModel.SECMBRID"
                                            [disabled]="disabled" [maxlength]="16" (onValueChange)="enrollmentViewModel.SECMBRID=$event"
                                            [validators]="[notBlankValidator,alphaNumericFieldValidator]">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedDropDown class="wide" [selectedValue]="enrollmentViewModel.RELCD"
                                           [label]="'Relationship Code'" [disabled]="'false'" (onValueChange)="relationChange($event)"
                                           [options]="RelCode">
                        </ValidatedDropDown>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField class="field field--single" [label]="'Family ID'" 
                                            [requiredField]="true" [text]="enrollmentViewModel.FAMILYID" [disabled]="disabled"
                                            [maxlength]="18" (onValueChange)="enrollmentViewModel.FAMILYID=$event"
                                            [validators]="[notBlankValidator,alphaNumericFieldValidator]">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedDropDown class="wide" [selectedValue]="enrollmentViewModel.PERSONCD"
                                           [label]="'Person Code'" [disabled]="'false'" (onValueChange)="personChange($event)"
                                           [options]="PersonCode">
                        </ValidatedDropDown>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField class="field field--single" [label]="'Care Facility(Optional)'"
                                            [id]="'Care Facility(Optional)'" [text]="enrollmentViewModel.CAREFAC" [disabled]="disabled"
                                            [maxlength]="40" (onValueChange)="enrollmentViewModel.CAREFAC=$event"
                                            [validators]="[alphaNumericFieldValidator]">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>

        </fieldset>
    </div>

    <!--
    <div class="row">
        <div class="col-24">
            <div *ngIf="PaperlessOption">
                <div class="row">
                    <div class="col-16">
                        <p><strong>Paperless Settings</strong></p>
                    </div>
                    <div class="col-16">
                        <p>
                            Once your application is complete, would you like to receive Medicare Part D documents electronically? This lets you keep your documents organized in one secure online location that’s always accessible.
                        </p>
                        <div class="row">
                            <br />
                        </div>
                        <p>
                            The types of documents include evidence of coverage, your formulary, a pharmacy directory, explanation of benefit statements, plan coverage information, billing information and general plan information and messaging. You can go back to mailed versions at any time.
                        </p>

                    </div>

                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20">
                            <ValidatedCheckbox [id]="'eobOption'"
                                               [label]="eobOptionLabel"
                                               [checked]="enrollmentViewModel.EOB==='3'"
                                               (onValueChange)="eobOptionChanged($event)">
                            </ValidatedCheckbox>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <p>
                            Once you enroll, or if you are already a returning member, you can go back to mailed versions at any time on <a class="link" href="https://www.caremark.com" target="_blank">Caremark.com</a>.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="bottom-20">
                            <label>{{emailLabel}}</label>
                            <ValidatedTextField class="" [maxlength]="40"
                                                [label]=""
                                                id="EmailAddress"
                                                [text]="enrollmentViewModel.APPEMAIL"
                                                (onValueChange)="enrollmentViewModel.APPEMAIL = $event">

                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    -->


    <div class="row">
        <div class="col-16">
            <ValidatedRadioButtonGroup label="Election Period" labelClass="black-text" [options]="electionPeriodsList"
                                       [selectedValue]="enrollmentViewModel.ELECTION" [radioGroupName]="'electionPeriod'">
            </ValidatedRadioButtonGroup>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div>
                <p>I am leaving/losing/joining employer or union coverage. My coverage changed or will change on</p>
                <JQDatePicker for="SEPEFFDT" [label]="'Election Option:'" id="SEPEFFDT" [selectedDate]="enrollmentViewModel.SEPEFFDT"
                              (elementClicked)="enrollmentViewModel.SEPEFFDT = $event">
                </JQDatePicker>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <p>
                <br /> <br />
            </p>
        </div>
    </div>

    <div class="row">
        <div class="col-16">
            <p>
                <b>
                    You can pay your monthly plan premium (including any late enrollment penalty you may owe) by mail
                    each month. You can also choose to pay your premium by automatic deduction from your Social Security
                    or Railroad Retirement Board benefit check each month.
                    If you are assessed a Part D-Income Related Monthly Adjustment Amount, you will be notified by the
                    Social Security Administration. You will be responsible for paying this extra amount in addition to
                    your plan premium. You will either have the amount withheld from your Social Security or Railroad
                    Retirement Board benefit check or be billed directly by Medicare. Do NOT pay the Part D-IRMAA extra
                    amount to Blue MedicareRx.
                </b>
                <br /><br />
            </p>
            <p>
                People with limited incomes may qualify for Extra Help to pay for their prescription drug costs. If you
                qualify, Medicare could pay for 75% or more of your drug costs including monthly prescription drug
                premiums, annual deductibles, and co-insurance. Additionally, those who qualify won’t have a coverage
                gap or a late enrollment penalty. Many people are eligible for these savings and don’t even know it. For
                more information about this Extra Help, contact your local Social Security office, or call Social
                Security at 1-800-772-1213. TTY users should call 1-800-325-0778. You can also apply for Extra Help
                online at <a class="link" href="http://www.socialsecurity.gov/prescriptionhelp"
                             target="_blank">www.socialsecurity.gov/prescriptionhelp</a>.

            </p>
            <br /> <br />
            <p>
                If you qualify for Extra Help with your Medicare prescription drug coverage costs, Medicare will pay all
                or part of your plan premium. If Medicare pays only a portion of this premium, we will bill you for the
                amount that Medicare doesn’t cover.
                <br /><br />
            </p>
            <p>
                <b>Please select a premium payment option.</b> (If you don’t select an option, you will receive a
                monthly bill.) Reminder, if you have secondary coverage that pays for part of your premiums (for
                example: from your employer or an SPAP) then you must choose monthly bills that you can pay by mail in
                order for the secondary coverage to be applied correctly.
            </p>
            <br />
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <ValidatedRadioButtonGroup label="How would you like to pay for the monthly premium?"
                                       labelClass="black-text" [options]="paymentOptions" [selectedValue]="enrollmentViewModel.PWO"
                                       [radioGroupName]="'PaymentOptions'" (onValueChange)="paymentOptionChanged($event)">
            </ValidatedRadioButtonGroup>
        </div>
    </div>

    <div class="row" *ngIf="IsAutomatciSocial">
        <div class="col-16">
            <div class="bottom-20">
                <p>
                    (Your monthly plan premium deduction may take up to 90 days to begin and will not cover any premiums
                    for which we have already sent you an invoice. Therefore, until your automatic deduction is
                    approved, we will continue to send you a paper bill each month. Please continue to pay your premium
                    invoice for as long as you receive it. In most cases, if Social Security/ Railroad Retirement Board
                    accepts your request for automatic deduction, the first deduction from your Social Security/Railroad
                    Retirement Board benefit might not include all premiums owed from your enrollment effective date up
                    to the point withholding begins. If you owe any premiums retroactive to the date of the Social
                    Security/Railroad Retirement Board deductions, we will send you a paper bill for those premiums. If
                    Social Security/Railroad Retirement Board does not approve your request for automatic deductions, we
                    will send you a paper bill for your monthly premiums.) Note: the option to pay using a Credit Card
                    will be included on your monthly invoice. You can also call us toll free once your enrollment in the
                    plan is active, at 1-866-832-9775, 24 hours a day, 7 days a week. TTY/TDD users call 711.
                </p>
            </div>
        </div>

    </div>
    <div class="row" *ngIf="IsAUTOMATIC_RAILROAD">
        <div class="col-16">
            <div class="bottom-20">
                <p>
                    (Your monthly plan premium deduction may take up to 90 days to begin and will not cover any premiums
                    for which we have already sent you an invoice. Therefore, until your automatic deduction is
                    approved, we will continue to send you a paper bill each month. Please continue to pay your premium
                    invoice for as long as you receive it. In most cases, if Social Security/ Railroad Retirement Board
                    accepts your request for automatic deduction, the first deduction from your Social Security/Railroad
                    Retirement Board benefit might not include all premiums owed from your enrollment effective date up
                    to the point withholding begins. If you owe any premiums retroactive to the date of the Social
                    Security/Railroad Retirement Board deductions, we will send you a paper bill for those premiums. If
                    Social Security/Railroad Retirement Board does not approve your request for automatic deductions, we
                    will send you a paper bill for your monthly premiums.) Note: the option to pay using a Credit Card
                    will be included on your monthly invoice. You can also call us toll free once your enrollment in the
                    plan is active, at 1-866-832-9775, 24 hours a day, 7 days a week. TTY/TDD users call 711.
                </p>
            </div>
        </div>

    </div>

    <div *ngIf="IsElectronicFund">
        <div class="row">
            <div class="col-16">
                <p>
                    Please send us a VOIDED check and fill in the requested information, which allows us to deduct your
                    monthly premium payment from your bank account.<br />
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField class="field field--single"
                                        [label]="'Name on Account (Alphanumeric Characters Only):'" id="name-on-account"
                                        [text]="enrollmentViewModel.ACCHOLDERNAME"
                                        (onValueChange)="enrollmentViewModel.ACCHOLDERNAME = $event" [validators]="[]">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <ValidatedRadioButtonGroup label="Type of Account" id="account-type"
                                           radioGroupName="account-type-radio-group" [options]="accountTypeOptions"
                                           [selectedValue]="enrollmentViewModel.EFTTYPE" (onValueChange)="enrollmentViewModel.EFTTYPE = $event"
                                           [validators]="[]">
                </ValidatedRadioButtonGroup>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField class="field field--single"
                                        [label]="'Financial Institution (Alphanumeric Characters Only):'" id="financial-institution"
                                        [text]="enrollmentViewModel.FININSTNAME"
                                        (onValueChange)="enrollmentViewModel.FININSTNAME = $event" [validators]="[]">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField class="field field--single" [label]="'Routing Number'" id="routing-number"
                                        [text]="enrollmentViewModel.ROUTINGNB" (onValueChange)="enrollmentViewModel.ROUTINGNB = $event"
                                        [maxlength]="9" [validators]="[]">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField class="field field--single" [label]="'Account Number'" id="account-number"
                                        [text]="enrollmentViewModel.ACCOUNTNB" [maxlength]="15"
                                        (onValueChange)="enrollmentViewModel.ACCOUNTNB = $event" [validators]="[]">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p class="bottom-20">
                    <i>
                        By selecting Automatic Bank Withdrawal, I authorize the bank or financial
                        organization named above to pay my premium through electronic bank withdrawal payable to Blue
                        MedicareRx. I authorize the deduction of up to $300 at a time (only if the balance is such). The
                        bank or other financial organization will be fully protected in honoring these payments until
                        notice from me canceling this request is received.
                    </i>
                </p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <p>
                1. Some individuals may have other drug coverage, including other private insurance, TRICARE, Federal
                employee health benefits coverage, VA benefits, or State pharmaceutical assistance programs.
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <ValidatedRadioButtonGroup label="Will you have other prescription drug coverage in addition to Blue
                MedicareRx? (optional)" labelClass="black-text" [options]="rblSecondaryCoverage"
                                       [radioGroupName]="'rblSecondaryCoverage'" [selectedValue]="enrollmentViewModel.OTHCVRG"
                                       (onValueChange)="ShowCoverageInfo($event)">
            </ValidatedRadioButtonGroup>
        </div>
    </div>

    <div *ngIf="IsCovergInfoYes">
        <div class="row">
            <div class="col-16">
                <p>
                    If “yes”, please list your other coverage and your identification (ID) number(s) for this coverage:
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Name of other coverage'" [text]="enrollmentViewModel.OTHCVRGNAME"
                                        [validators]="[]" (onValueChange)="enrollmentViewModel.OTHCVRGNAME = $event">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'ID# for this coverage (optional)'"
                                        [text]="enrollmentViewModel.OTHCVRGID" (onValueChange)="enrollmentViewModel.OTHCVRGID = $event">

                    </ValidatedTextField>
                </div>

            </div>

        </div>

        <div class="row">

            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Group # for this coverage (optional)'"
                                        [text]="enrollmentViewModel.OTHCVRGGRP"
                                        (onValueChange)="enrollmentViewModel.OTHCVRGGRP = $event">

                    </ValidatedTextField>
                </div>

            </div>

        </div>

    </div>
    <div class="row">
        <div class="col-16">
            <ValidatedRadioButtonGroup label="2.Are you a resident in a long-term care facility, such as a nursing home?
                (optional)" labelClass="black-text" [options]="rbllongTerm"
                                       [selectedValue]="enrollmentViewModel.RBLLONGTERM" [radioGroupName]="'rbllongTerm'"
                                       (onValueChange)="ShowrbllongtermOptions($event)">
            </ValidatedRadioButtonGroup>
        </div>
    </div>
    <div class="row">
        <fieldset class="radio" *ngIf="IsRbllongtermYes">
            <legend>Long term care facility:</legend>
            <div class="col-16">
                <p>
                    If “yes” please provide the following information:
                </p>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField label="Name of Facility:" [maxlength]="50"
                                            [text]="enrollmentViewModel.LTCFACILITY"
                                            (onValueChange)="enrollmentViewModel.LTCFACILITY= $event">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField label="Address of Facility (optional):" [maxlength]="150"
                                            [text]="enrollmentViewModel.LTCADD1" (onValueChange)="enrollmentViewModel.LTCADD1= $event">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <MaskedValidatedTextField class="field" [label]="'Phone Number of Facility:(numbers only)'"
                                                  id="ltc-phone" [text]="enrollmentViewModel.LTCPHONE"
                                                  (onValueChange)="enrollmentViewModel.LTCPHONE = $event" [maxlength]="10"
                                                  [inputMask]="phoneNumberInputMask">
                        </MaskedValidatedTextField>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
    <div class="row" *ngIf="false">
        <br />
        <div class="col-16">
            <label>
                Please check the box below if you would prefer that we send you information in another format:
            </label>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="input-wrapper">
                    <ValidatedCheckbox class="centered-checkbox" [id]="'large-print'" [label]="'Large Print'"
                                       [checked]="enrollmentViewModel.LANGFORMAT"
                                       (onValueChange)="enrollmentViewModel.LANGFORMAT= $event">
                    </ValidatedCheckbox>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="visibleFrom2025">
        <div class="col-22">
            <genderPref [enrollmentgenderPrefyViewModel]="enrollmentViewModel"></genderPref>
        </div>
    </div>
    <div class="row">
        <br />
        <div class="col-16">
            <p>
                Please contact Blue MedicareRx at 1-866-832-9775 if you need information in a format other than what is
                listed above. TTY/TDD users should call 711. Our office hours are 24 hours a day, 7 days a week
                <br />
            </p>
            <p>
                <b> Please read:</b> <br />
                If you are a member of a Medicare Advantage Plan (like an HMO or PPO), you may already have prescription
                drug coverage from your Medicare Advantage Plan that will meet your needs. By joining Blue MedicareRx,
                your membership in your Medicare Advantage Plan may end. This will affect both your doctor and hospital
                coverage as well as your prescription drug coverage. Read the information that your Medicare Advantage
                Plan sends you and if you have questions, contact your Medicare Advantage Plan.
                <br />

            </p>
            <p>
                If you currently have health coverage from an employer or union, joining Blue MedicareRx could affect
                your employer or union health benefits. You could lose your employer or union health coverage if you
                join Blue MedicareRx. Read the communications your employer or union sends you. If you have questions,
                visit their website, or contact the office listed in their communications. If there isn't information on
                whom to contact, your benefits administrator or the office that answers questions about your coverage
                can help.
                <br />
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <label for="Notes">Notes (max 300 characters)(optional)</label>
            <textarea rows="3" cols="60" name="txtNotes" [(ngModel)]="enrollmentViewModel.NOTES"
                      maxlength="300" id="Notes"></textarea>
        </div>

    </div>

    <div class="row">
        <div class="col-24">
            <button class="button cancel" (click)="onBack()">Go Back and Make Changes</button>
        </div>
    </div>
    <div class="row" *ngIf="!isIndv">
        <div class="col-24">
            <button class="button primary" (click)="incompleteClick()">Continue As Incomplete</button>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary" (click)="formSubmit()">Continue</button>
        </div>
    </div>
</div>
<style>
    fieldset {
        border: 4px solid #ccc;
        padding: 1rem;
        margin-top: 1rem;
        border-radius: 5px;
        margin-bottom: 1rem;
    }

    legend {
        font-size: 1.1rem;
        font-weight: bold;
    }
</style>